
























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import * as _ from 'lodash'
import { User } from '@/core/Types'
import { Subscription } from '@/core/ApiTypes'
import Spinner from '@/components/Spinner.vue'
import appManager from '@/services/AppManager'
import { getSubscriptionStatusColor, getSubscriptionStatusText } from '@/model/Helpers'
import SubscriptionPeriodEndComponent from '@/components/subscriptions/SubscriptionPeriodEndComponent.vue'

@Component({
    components: {
        Spinner,
        SubscriptionPeriodEndComponent
    }
})
export default class UserSubscriptionComponent extends Vue {
    @Prop()
    user: User|undefined
    @Prop()
    onAssignSubscriptionRequested: ((user: User) => void)|undefined
    subscriptionId: string|null = null
    subscription: Subscription|null = null
    subscriptionCounter: number = 0 // simple way to force a refresh when the subscription changes

    async created(): Promise<void> {
        await this.reloadSubscription()
    }

    // noinspection JSUnusedGlobalSymbols
    async updated(): Promise<void> {
        const newSubscriptionId = _.first(this.user?.data?.stripeSubscriptionIds) || null
        if (newSubscriptionId !== this.subscriptionId)
            await this.reloadSubscription()
    }

    async reloadSubscription(): Promise<void> {
        this.subscription = null
        this.subscriptionId = _.first(this.user?.data?.stripeSubscriptionIds) || null
        if (this.subscriptionId) {
            try {
                this.subscription = await appManager.subscriptionManager.getSubscription(this.subscriptionId)
            } catch (error) {
                console.error(`Error Loading Subscription: ${error}`)
            }
        }

        this.subscriptionCounter += 1
    }

    getSubscriptionStatusColorLocal(subscription: Subscription): string {
        return getSubscriptionStatusColor(subscription)
    }

    getSubscriptionStatusTextLocal(subscription: Subscription): string {
        return getSubscriptionStatusText(subscription)
    }

    onAssignSubscriptionPressed() {
        if (this.user && this.onAssignSubscriptionRequested)
            this.onAssignSubscriptionRequested(this.user)
    }
}
